import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import StaysList from "@/pages/stays/StaysList";
import StaysMapSearch from "@/pages/stays/StaysMapSearch";
import PropertyDetail from "@/pages/stays/PropertyDetail";
import RoomBooking from "@/pages/stays/RoomBooking";
import CheckoutConfirm from "@/pages/stays/CheckoutConfirm";
import Wishlist from "@/pages/stays/Wishlist";
import Profile from "@/pages/stays/Profile";
import BookingStatus from "@/pages/booking/BookingStatus";
import BookingLookup from "@/pages/booking/BookingLookup";
import AdminApp from "@/pages/admin/AdminApp";
import Login from "@/pages/Login";
import Pro from "@/pages/Pro";
import { AuthProvider } from "@/context/AuthContext";

const ScrollManager = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) window.__lenis = lenis;
  }, [lenis]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <ScrollManager />
        <AuthProvider>
        <Routes>
          <Route path="/" element={<StaysList />} />
          <Route path="/home" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/pro" element={<Pro />} />
          <Route path="/stays" element={<StaysList />} />
          <Route path="/stays/search" element={<StaysMapSearch />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/stays/:propertyId" element={<PropertyDetail />} />
          <Route path="/stays/:propertyId/:roomId" element={<RoomBooking />} />
          <Route path="/book/confirm" element={<CheckoutConfirm />} />
          {/* Deep-link aliases so external apps can link via /property/:id */}
          <Route path="/property/:propertyId" element={<PropertyDetail />} />
          <Route path="/property/:propertyId/:roomId" element={<RoomBooking />} />
          <Route path="/booking/lookup" element={<BookingLookup />} />
          <Route path="/booking/:id/status" element={<BookingStatus />} />
          <Route path="/admin" element={<AdminApp />} />
          <Route path="/login" element={<Login />} />
        </Routes>
        </AuthProvider>
        <Toaster position="bottom-right" richColors />
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
